function disableDefaultArrowPresses(targetEl) {
  const fnCancelArrows = (e) => {
    switch (event.key) {
    case 'ArrowUp':
    case 'ArrowDown':
    case 'ArrowLeft':
    case 'ArrowRight':
      event.preventDefault();
      
    default:
      // Intentionally blank
    }
  };
  
  targetEl.addEventListener('keydown', fnCancelArrows); 
  targetEl.addEventListener('keyup', fnCancelArrows); 
}

export default {
  disableDefaultArrowPresses
}